import React, { useState } from "react";
import RegisterImage from "../assest/images/Bg_Login.jpg";
import apiInstance from "../apiConfig/apiinstance";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { toggleModal, openModal } from "../Redux/modalSlice";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function RegisterPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm_password, setconfirm_password] = useState("");
  // const [error, setError] = useState(null);
  const [passwordMatchError, setPasswordMatchError] = useState("");
  const [touched, setTouched] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleclick() {
    dispatch(openModal());
    navigate("/");
  }

  // Check if passwords match
  const checkPasswordMatch = (pwd, confirmPwd) => {
    if (confirmPwd && pwd !== confirmPwd) {
      setPasswordMatchError("Passwords do not match");
    } else {
      setPasswordMatchError("");
    }
  };

  // Handle input changes
  const handleInputChange = (field, value) => {
    switch (field) {
      case "name":
        setName(value);
        break;
      case "email":
        setEmail(value);
        break;
      case "password":
        setPassword(value);
        // Check password match when password changes
        checkPasswordMatch(value, confirm_password);
        break;
      case "confirm_password":
        setconfirm_password(value);
        // Check password match when confirm password changes
        checkPasswordMatch(password, value);
        break;
      default:
        break;
    }
  };

  // Handle field blur
  const handleBlur = (field) => {
    setTouched((prev) => ({ ...prev, [field]: true }));
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    // console.log("Registering user:", { name, email, password });

    if (password !== confirm_password) {
      setPasswordMatchError("Passwords do not match");
      setTouched({ confirm_password: true });
      toast.error("Passwords do not match");
      return;
    }

    const payload = {
      name,
      email,
      password,
      confirm_password,
    };

    setLoading(true);
    try {
      const { data } = await apiInstance.post(
        `/api/auth/v1/auth/register/`,
        payload
      );
      if (data.status === 201) {
        // console.log(data);
        toast.success("Varification email sent successfully");
        navigate("/");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error registering user");
      // console.log("error in register", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 relative">
      <img
        src={RegisterImage}
        alt="login-bg"
        className="w-full h-full absolute top-0 left-0 object-cover opacity-50"
      />
      <form
        onSubmit={handleRegister}
        className="bg-white md:p-8 p-4 rounded shadow-md w-full m-2 z-10 md:text-2xl md:max-w-[35rem]"
      >
        <h2 className="text-2xl font-bold mb-6 text-center">Register</h2>
        <input
          type="text"
          placeholder="Full Name"
          value={name}
          onChange={(e) => handleInputChange("name", e.target.value)}
          required
          className="w-full mb-4 p-3 border border-gray-300 rounded"
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => handleInputChange("email", e.target.value)}
          required
          className="w-full mb-4 p-3 border border-gray-300 rounded"
        />
        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            onChange={(e) => handleInputChange("password", e.target.value)}
            required
            className="w-full mb-4 p-3 border border-gray-300 rounded pr-10"
          />
          <span
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-3 text-gray-600 cursor-pointer"
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>
        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={confirm_password}
            onChange={(e) =>
              handleInputChange("confirm_password", e.target.value)
            }
            required
            className="w-full mb-4 p-3 border border-gray-300 rounded pr-10"
          />
          <span
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-3 text-gray-600 cursor-pointer"
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        {touched.confirm_password && passwordMatchError && (
          <p className="text-red-500 text-sm mt-1">{passwordMatchError}</p>
        )}

        <button
          type="submit"
          disabled={loading || passwordMatchError}
          className={`w-full bg-green-600 text-white py-3 rounded hover:bg-green-700 transition disabled:bg-gray-400`}
        >
          {loading ? "Registering..." : "Register"}
        </button>
        <p className="text-center mt-4 text-gray-600">
          Already have an account?{" "}
          <a onClick={handleclick} className="text-blue-600 hover:underline">
            Login
          </a>
        </p>
      </form>
    </div>
  );
}

export default RegisterPage;
